import { useEffect, useState } from "react";

// Breakpoints aligned to the brand layout rules (mobile / tablet / desktop).
export const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1080 } as const;
export type Breakpoint = keyof typeof BREAKPOINTS;

function compute(width: number): Breakpoint {
  if (width >= BREAKPOINTS.desktop) return "desktop";
  if (width >= BREAKPOINTS.tablet) return "tablet";
  return "mobile";
}

/** Current breakpoint + convenience flags. Drives the responsive shell
    (desktop sidebar ↔ mobile bottom-tab bar) without separate mobile files. */
export function useResponsive() {
  const [bp, setBp] = useState<Breakpoint>(() =>
    typeof window === "undefined" ? "desktop" : compute(window.innerWidth),
  );

  useEffect(() => {
    let frame = 0;
    const onResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setBp(compute(window.innerWidth)));
    };
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return {
    breakpoint: bp,
    isMobile: bp === "mobile",
    isTablet: bp === "tablet",
    isDesktop: bp === "desktop",
  };
}
